import React from 'react';
import {useThemeContextProvider} from '../../../state';
import {useWindowSize} from '../../../../../general';

function decodeHtml(html) {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
}

export const Blocks = () => {
    const {blockDataDesktop, blockDataMobile} = useThemeContextProvider();
    const {isMobile, isTablet} = useWindowSize();

    const renderBlockContent = (blockData) => {
        if (!blockData) return null;
        return <div dangerouslySetInnerHTML={{__html: decodeHtml(blockData.content)}}></div>;
    };

    // Pentru mobile și tablet afișez blocul mobile, pentru desktop blocul desktop
    const shouldShowMobile = isMobile || isTablet;

    return (
        <div className={'mb-0 xl:mb-12 mt-3 xl:mt-0'}>
            {!shouldShowMobile && (
                <div className={'desktop-footer ml-[10%]'}>
                    {renderBlockContent(blockDataDesktop)}
                </div>
            )}

            {shouldShowMobile && blockDataMobile && (
                <div className={'mobile-footer p-5'}>
                    {renderBlockContent(blockDataMobile)}
                </div>
            )}
        </div>
    );
};